import { render } from "./Header.vue?vue&type=template&id=79b5cf5e&scoped=true&ts=true"
import script from "./Header.vue?vue&type=script&lang=ts"
export * from "./Header.vue?vue&type=script&lang=ts"

import "./Header.vue?vue&type=style&index=0&id=79b5cf5e&scoped=true&lang=css"

import exportComponent from "/home/runner/work/miki-ihara-law-and-patent-office/miki-ihara-law-and-patent-office/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-79b5cf5e"]])

export default __exports__